<template>
  <!--创建订单弹出框-->
  <div class="D-date">
    <div class="leaderBox" v-if="showOrhide">
      <div class="newtext">新手指引</div>
      <img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
      <img src="../../assets/images/ding-tan1.png" class="steps step1" v-if="status==1">
      <img src="../../assets/images/ding-tan2.png" class="steps step2" v-if="status==2">
      <div class="stepbtn" @click="nextStep(status)">
        {{status==1?"下一步":status==2?"我知道了":"我知道了"}}
      </div>
      <div class="bottomTip">
        <el-checkbox v-model="checked">下次不再提示</el-checkbox>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" v-bind="$attrs" v-on="$listeners" class="h-dialog2">
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>新建订单信息</h1>
          </div>
        </div>
      </div>
      <div class="h-formLine">
        <el-form ref="form" :model="order" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
          <el-form-item label="订单类型" class="h-elformWrap-2">
            <el-cascader :options="orderTypeList" :props="{
                                        value: 'code',
                                        label: 'name',
                                    }" v-model="ruleForm" @change="handleOrderChange">
            </el-cascader>
          </el-form-item>
          <el-form-item label="项目名称" class="h-elformWrap-2" v-show="xiangmuTab">
            <el-select v-model="order.orderProjectCode" filterable placeholder="请选择" clearable @change="getProjectName">
              <el-option v-for="item in allProjectByUser" :key="item.id" :label="item.projectName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合同名称" class="h-elformWrap-2" v-show="hetongTab">
            <el-select v-model="order.orderMainContract" filterable placeholder="请选择" clearable>
              <el-option v-for="item in contractList" :key="item.id" :label="item.contractName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合同名称" class="h-elformWrap-2" v-show="nwsaleHetongTab">
            <el-select v-model="order.orderMainContract" filterable placeholder="请选择" clearable>
              <el-option v-for="item in contractList" :key="item.id" :label="item.contractName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="销售组织" v-show="saleGroupCodeTab" class="h-elformWrap-2">
            <el-select v-model="order.saleGroupCode" @change="xszzhandleChange">
              <el-option v-for="item in xszz" :key="item.code" :label="`[${item.code}]${item.name}`" :value="item.code" />
            </el-select>
          </el-form-item>
          <el-form-item label="分销渠道" v-show="disChannelCodeTab" class="h-elformWrap-2">
            <el-cascader style="width:100%;" :options="fxqd" v-model="order.disChannelCode" :props="{
                                        value: 'code',
                                        label: 'name',
                                    }">
            </el-cascader>
          </el-form-item>
          <!--                    <el-form-item label="服务订单类型" class="h-elformWrap-2" v-if="this.order.orderCategory1==9">
                        <el-cascader
                                :options="fwnwxchildren"
                                v-model="order.orderCategory2"
                                :props="{
                                        value: 'code',
                                        label: 'name',
                                    }"
                                @change="handleOrderChangeFw" >
                        </el-cascader>
                    </el-form-item>-->
          <el-form-item label="退货类型" class="h-elformWrap-2" prop="orderCategory2" v-if="this.order.orderCategory1==14">
            <el-select v-model="order.orderCategory2" placeholder="请选择">
              <el-option v-for="(item) in thList" :key="item.value" :label="item.label" :value="item.value" @change="handleOrderChangeTh($event)">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务类型" class="h-elformWrap-2" prop="orderCategory2" v-if="this.order.orderCategory1==9">
            <el-select v-model="order.orderCategory2" placeholder="请选择">
              <el-option v-for="(item) in fwnwxchildren" :key="item.value" :label="item.label" :value="item.value" @change="handleOrderChangeFw">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="免费类型" class="h-elformWrap-2" prop="orderCategory2" v-if="this.order.orderCategory1==6 || this.order.orderCategory1==23 || this.order.orderCategory1==29">
            <!--                        <brselect clearable category="xiaoshou_quyu_nwx_mf" :v="order.orderCategory2"
                                  v-model="order.orderCategory2"></brselect>-->
            <desselect clearable category="xiaoshou_quyu_nwx_mf" :des="this.typeDes" :v="order.orderCategory2" v-model="order.orderCategory2"></desselect>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="h-btn h-formBtn h-bgwhite" @click="cancel">取 消</el-button>
        <el-button class="h-btn h-formBtn h-bgblueQ2" @click="saveTo">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ss from '../../api/SystemService'
export default {
  data () {
    return {

      nwxchildren: [],

      onenum: [],
      twonum: [],
      // 新手引导
      toshow: 'dingdAdd',
      checked: true,
      showOrhide: false,
      status: 1,
      // 新手引导结束
      hetongTab: false,
      nwsaleHetongTab: false,
      contractList: [],

      orderTypeList: [],
      fwnwxchildren: [],
      mfChildTypeList: [],
      nbyh: false,
      //用户项目
      allProjectByUser: [],
      //是否有项目
      xiangmuTab: false,
      saleGroupCodeTab: true,
      disChannelCodeTab: true,
      fwnwxchildren: [
        {
          value: '1',
          label: '标准服务订单'
        },

/*                {
                    value: '2',
                    label: '直单服务订单'
                },*/ {
          value: '3',
          label: '3Q服务订单'
        }, {
          value: '4',
          label: '3Q特价订单'
        },
        {
          value: '5',
          label: '市场免费服务订单'
        },
        {
          value: '6',
          label: '质量免费服务订单'
        }, {
          value: '7',
          label: '售后服务订单'
        }

      ],
      thList: [
        {
          value: '0',
          label: '普通订单退货'
        },
        {
          value: '1',
          label: '买赠订单退货'
        },
      ],
      //销售组织，下拉
      xszz: [],
      fxqd: [],
      order: {
        orderMainContract: null, // 主合同编号
        orderSubContract: null, // 分合同编号
        orderProjectCode: null, // 项目编号
        orderProjectName: null, // 项目名称
        orderCategory: null, // 订单类型
        orderCategory1: null, // 订单详细类型
        orderCategory2: null,
        saleGroupCode: null, // 销售组织编码
        disChannelCode: null, // 分销渠道编码
        zcode: null, // 分销渠道编码-子编码
        soldToCode: null,//售达方
        poId: null
      },
      typeDes: '',
      ruleForm: [],
    }
  },


  created () {
    // 遮罩
    this.showzhezhao()

    this.orderTypeList = this.$store.getters.dictlist("xiaoshou_quyu");
    let nwxchildren = this.$store.getters.dictlist("xiaoshou_quyu_nwx");

    var usercode = {

      usercode: this._user.usercode,

    }

    ss.chanpin.huoquguanxikexuan(usercode).then(rd => {

      // console.log(rd.obj,'看看筛选')

      this.orderTypeList = _.filter(this.orderTypeList, (o) => {
        return _.includes(rd.obj.one, o.code);
      })
      //如果是分销商 排除套餐订单
      if (this.$store.getters.hasRole('second_agent')) {
        nwxchildren = _.filter(nwxchildren, (o) => {
          if (o.code != '12') {
            return _.includes(rd.obj.two, o.code);
          }
        })
      } else {
        nwxchildren = _.filter(nwxchildren, (o) => {
          return _.includes(rd.obj.two, o.code);
        })
      }

      // console.log(this.orderTypeList,'this.orderTypeList')
      // console.log(nwxchildren,'nwxchildren')

      // console.log('我在这儿呀', this.orderTypeList);
      //内部用户
      this.nbyh = this.$store.getters.isnbyh;
      // console.log(this.nbyh)


      // //不是内部用户
      // if(!this.nbyh){
      //     this.saleGroupCodeTab = false;
      //     this.disChannelCodeTab = false;
      //     var c1 = ['1'];
      //     var c2 = ['1','2','3','7','9','11'];
      //     this.orderTypeList = _.filter(this.orderTypeList,(o)=>{
      //         return _.includes(c1,o.code);
      //     })
      //     nwxchildren = _.filter(nwxchildren,(o)=>{
      //         return _.includes(c2,o.code);
      //     })
      // }

      this.orderTypeList.forEach((obj, i) => {
        var zlist = _.filter(nwxchildren, { pid: obj.id });
        if (zlist && zlist.length > 0) {
          obj.children = zlist;
        }
      })

      this.fxqd = this.$store.getters.dictlist("fenxiao_qudao");
      _.find(this.fxqd, { code: 'Z1' }).children = this.$store.getters.dictlist("fenxiao_qudao_shanghai");

      this.allxszz = this.$store.getters.dictlist('YLSalesOrganization_agent');
      this.allfxqd = this.$store.getters.dictlist('fenxiao_qudao');

      console.log(this.allxszz)
      console.log(this.allfxqd)


    })

    //订单关联漏斗默认选中订单类型
    if (this.isloud == 1) {
      if (this.ddlx == "1,1") {
        this.ruleForm = ["1", "1"];
      } else if (this.ddlx == "1,2") {
        this.ruleForm = ["1", "2"];
      } else if (this.ddlx == "1,11") {
        this.ruleForm = ["1", "11"];
      } else if (this.ddlx == "1,12") {
        this.ruleForm = ["1", "12"];
      }
      this.handleOrderChange(this.ruleForm);
    }
  },
  methods: {
    listContract () {
      ss.OrderService.getContractList().then(rd => {
        this.contractList = rd;
      });
    },
    nwSaleListContract (value) {
      ss.OrderService.nwSaleListContract(value).then(rd => {
        this.contractList = rd;
      });
    },
    //设置项目信息
    listPro () {
      ss.OrderService.projectManagePageG({ orderCategory: this.order.orderCategory, orderCategory1: this.order.orderCategory1 }).then(rd => {
        this.allProjectByUser = rd;
      });
    },
    getProjectName (v) {
      let item = _.find(this.allProjectByUser, { id: v });
      this.order.orderProjectName = item.projectName;
      this.order.poId = item.poId;
      this.order.soldToCode = item.customerId;
    },

    //订单类型改变后方法
    handleOrderChange (value) {
      console.log(value, '???aaa')
      this.xiangmuTab = false;
      this.order.orderProjectName = null;
      this.order.poId = null;
      this.order.soldToCode = null;
      this.hetongTab = false;
      this.order.orderProjectCode = null;
      this.order.orderProjectName = null;
      this.allProjectByUser = [];
      var v1 = value[0];
      var v2 = value[1] || '';
      this.order.orderCategory = value[0];
      this.order.orderCategory1 = value[1] || '';
      console.log("111122223333", this.order.orderCategory1)
      this.order.orderCategory2 = value[2] || '';

      if (this.$store.getters.hasRole('swyl_admin') || this.order.orderCategory1 == '23' || this.order.orderCategory1 == '29') {
        this.typeDes = '';
      } else if (this.order.orderCategory1 == '6') {
        if (this.$store.getters.hasRole('swyl_xiaoshoujl_kangsheng,hh_shichangneiqin')) {
          this.typeDes = '';
        } else if (this.$store.getters.hasRole('shouh_jingli')) {
          this.typeDes = '售后经理';
        } else {
          this.typeDes = '市场人员';
        }
      }

      if (v1 == '1') {
        this.saleGroupCodeTab = false;
        this.disChannelCodeTab = false;



        //销售组织
        // this.xszz = _.filter(this.allxszz,(o)=>{
        //     return _.includes(['9390','9370'],o.code);
        // })
        // this.order.saleGroupCode = '9390'
        // 项目
        if (v2 == '1' || v2 == '7') {
          this.xiangmuTab = true;
          this.listPro();
        } else if (v2 == '8') {
          this.hetongTab = true;
          this.listContract();
        }
        //分销渠道
        this.order.disChannelCode = '00';
        // this.fxqd = _.filter(this.allfxqd,{code:'00'})
        //外销
      } else if (v1 == '2') {

        this.saleGroupCodeTab = true;
        this.disChannelCodeTab = true;

        //项目
        if (v2 != '23' && v2 != '25' && v2 != '29') {
          this.xiangmuTab = true;
        }
        this.listPro();
        if (v2 == '27') {
          //销售组织
          this.xszz = _.filter(this.allxszz, (o) => {
            return _.includes(['6200'], o.code);
          })
          this.order.saleGroupCode = '6200'
          //分销渠道
          this.order.disChannelCode = 'X1';
          this.fxqd = _.filter(this.allfxqd, (o) => {
            return _.includes(['X1'], o.code);
          })

        } else if (v2 == '28') {
          //销售组织
          /*                    this.xszz = _.filter(this.allxszz,(o)=>{
                                  //暂时只放开9390销售组织
                                  //return _.includes(['9370','9390'],o.code);
                                  return _.includes(['9390'],o.code);
                              })
                              this.order.saleGroupCode = '9390'
                              //分销渠道
                              this.order.disChannelCode = '00';
                              this.fxqd = _.filter(this.allfxqd,(o)=>{
                                  return _.includes(['00','X1'],o.code);
                              })*/
          this.xiangmuTab = false;
          this.saleGroupCodeTab = false;
          this.disChannelCodeTab = false;

          this.order.saleGroupCode = null;
          this.order.disChannelCode = null;
          this.xszz = null;
          this.fxqd = null;

        } else if (v2 == '29') {
          //销售组织
          this.xszz = _.filter(this.allxszz, (o) => {
            //暂时只放开9390销售组织
            return _.includes(['6200'], o.code);
          })
          this.order.saleGroupCode = '6200'
          //分销渠道
          this.order.disChannelCode = 'X1';
          this.fxqd = _.filter(this.allfxqd, (o) => {
            return _.includes(['X1'], o.code);
          })
        } else if (v2 == '25') {
          //销售组织
          this.xszz = _.filter(this.allxszz, (o) => {
            return _.includes(['6200', '9390', '1D90', '1JC0', '1RK0', '0PN0', '1R60', '1S00', '1S40', '44U0', '45K0'], o.code);
          })
          this.order.saleGroupCode = '9390'
          //分销渠道
          this.order.disChannelCode = '00';
          this.fxqd = _.filter(this.allfxqd, (o) => {
            return _.includes(['00', 'X1'], o.code);
          })
        } else if (v2 == '23') {
          //销售组织
          /*                    this.xszz = _.filter(this.allxszz,(o)=>{
                                  return _.includes(['6200','9390','1D90','1JC0','1RK0','9370'],o.code);
                              })
                              this.order.saleGroupCode = '1RK0'
                              //分销渠道
                              this.order.disChannelCode = '00';
                              this.fxqd = _.filter(this.allfxqd,(o)=>{
                                  return _.includes(['00','X1'],o.code);
                              })*/

          this.saleGroupCodeTab = false;
          this.disChannelCodeTab = false;

          this.order.saleGroupCode = null;
          this.order.disChannelCode = null;
          this.xszz = null;
          this.fxqd = null;


        } else if (v2 == '41') {
          //销售组织
          this.xszz = _.filter(this.allxszz, (o) => {
            return _.includes(['6A10'], o.code);
          })
          this.order.saleGroupCode = '6A10'
          //分销渠道
          this.order.disChannelCode = '00';
          this.fxqd = _.filter(this.allfxqd, (o) => {
            return _.includes(['00'], o.code);
          })
        } else if (v2 == '42') {
          //销售组织
          /*                    this.xszz = _.filter(this.allxszz,(o)=>{
                                  //暂时只放开9390销售组织
                                  //return _.includes(['9370','9390'],o.code);
                                  return _.includes(['9390'],o.code);
                              })
                              this.order.saleGroupCode = '9390'
                              //分销渠道
                              this.order.disChannelCode = '00';
                              this.fxqd = _.filter(this.allfxqd,(o)=>{
                                  return _.includes(['00','X1'],o.code);
                              })*/
          this.xiangmuTab = false;
          this.saleGroupCodeTab = false;
          this.disChannelCodeTab = false;
          this.order.saleGroupCode = '6200';
          this.order.disChannelCode = null;
          this.xszz = null;
          this.fxqd = null;
        } else if (v2 == '43') {
          this.xiangmuTab = false;
          this.saleGroupCodeTab = false;
          this.disChannelCodeTab = false;
          this.order.saleGroupCode = null;
          this.order.disChannelCode = null;
          this.xszz = null;
          this.fxqd = null;
          this.nwsaleHetongTab = true;
          let a = {};
          this.nwSaleListContract(a);
        }else if (v2 == '44') {
          //销售组织
          this.xszz = _.filter(this.allxszz, (o) => {
            return _.includes(['6200', '9390', '1D90', '1JC0', '1RK0', '0PN0', '1R60', '1S00', '1S40', '44U0', '45K0'], o.code);
          })
          this.order.saleGroupCode = '44U0'
          //分销渠道
          this.order.disChannelCode = '00';
          this.fxqd = _.filter(this.allfxqd, (o) => {
            return _.includes(['00', 'X1'], o.code);
          })
        } else {
          //销售组织
          this.xszz = _.filter(this.allxszz, (o) => {
            return _.includes(['6200', '9390', '1D90', '1JC0', '1RK0', '0PN0', '1R60', '1S00', '1S40', '44U0', '45K0'], o.code);
          })
          this.order.saleGroupCode = '9390'
          //分销渠道
          this.order.disChannelCode = '00';
          this.fxqd = _.filter(this.allfxqd, (o) => {
            return _.includes(['00', 'X1'], o.code);
          })
        }

      } else if (v1 == '3') {
        // 31 :标准
        // 32 ：oem
        // ZSH1	采购本部
        // ZSH3	第三方销售
        // ZSH2	第三方采购
        if (v2 == '31') {
          this.order.disChannelCode = 'Z1';
          this.order.zcode = 'ZSH1';
          this.disChannelCodeTab = false;
        } else if (v2 == '32') {
          this.disChannelCodeTab = true;
        } else if (v2 == '33') {
          this.order.disChannelCode = 'Z1';
          this.order.zcode = 'ZSH1';
          this.disChannelCodeTab = false;
        }

        this.saleGroupCodeTab = true;
        //    上海直销
        this.xszz = _.filter(this.allxszz, (o) => {
          return _.includes(['9391'], o.code);
        })
        this.order.saleGroupCode = '9391'
        this.fxqd = _.filter(this.allfxqd, { code: 'Z1' })
        this.fxqd.children = this.$store.getters.dictlist('fenxiao_qudao_shanghai');
        console.log(this.fxqd.children)
      }


    },
    handleOrderChangeTh (value) {
      console.log(value, '???aaa')
    },
    //订单类型改变后方法
    handleOrderChangeFw (value) {
      console.log(value, '???aaa')
      this.xiangmuTab = false;
      this.order.orderProjectName = null;
      this.order.poId = null;
      this.order.soldToCode = null;
      this.hetongTab = false;
      this.order.orderProjectCode = null;
      this.order.orderProjectName = null;
      this.allProjectByUser = [];
      var v1 = this.order.orderCategory;
      var v2 = this.order.orderCategory1;
      var v3 = this.order.orderCategory2 || '';
      console.log("测试v1输出", v1)
      console.log("测试v2输出", v2)
      console.log("测试v3输出", v3)
      if (v1 == '1') {
        this.saleGroupCodeTab = false;
        this.disChannelCodeTab = false;



        //销售组织
        // this.xszz = _.filter(this.allxszz,(o)=>{
        //     return _.includes(['9390','9370'],o.code);
        // })
        // this.order.saleGroupCode = '9390'
        // 项目
        if (v2 == '1' || v2 == '7') {
          this.xiangmuTab = true;
          this.listPro();
        } else if (v2 == '8') {
          this.hetongTab = true;
          this.listContract();
        }
        //分销渠道
        this.order.disChannelCode = '00';
        // this.fxqd = _.filter(this.allfxqd,{code:'00'})
        //外销
      } else if (v1 == '2') {

        //项目
        if (v2 != '23' && v2 != '25') {
          this.xiangmuTab = true;
        }
        this.listPro();
        //销售组织
        this.xszz = _.filter(this.allxszz, (o) => {
          return _.includes(['6200', '9390'], o.code);
        })
        this.order.saleGroupCode = '9390'
        //分销渠道
        this.order.disChannelCode = '00';
        this.fxqd = _.filter(this.allfxqd, (o) => {
          return _.includes(['00', 'X1'], o.code);
        })

      } else if (v1 == '3') {
        // 31 :标准
        // 32 ：oem
        // ZSH1	采购本部
        // ZSH3	第三方销售
        // ZSH2	第三方采购
        if (v2 == '31') {
          this.order.disChannelCode = 'Z1';
          this.order.zcode = 'ZSH1';
          this.disChannelCodeTab = false;
        } else if (v2 == '32') {
          this.disChannelCodeTab = true;
        } else if (v2 == '33') {
          this.order.disChannelCode = 'Z1';
          this.order.zcode = 'ZSH1';
          this.disChannelCodeTab = false;
        }

        this.saleGroupCodeTab = true;
        //    上海直销
        this.xszz = _.filter(this.allxszz, (o) => {
          return _.includes(['9391'], o.code);
        })
        this.order.saleGroupCode = '9391'
        this.fxqd = _.filter(this.allfxqd, { code: 'Z1' })
        this.fxqd.children = this.$store.getters.dictlist('fenxiao_qudao_shanghai');
        console.log(this.fxqd.children)
      }


    },
    xszzhandleChange (v) {
      // console.log("fenxiaoqudao",v)
      if (v == '6200') {
        //分销渠道
        this.order.disChannelCode = 'X1';
        this.fxqd = _.filter(this.allfxqd, (o) => {
          return _.includes(['X1'], o.code);
        })
      } else {
        //分销渠道
        this.order.disChannelCode = '00';
        this.fxqd = _.filter(this.allfxqd, (o) => {
          return _.includes(['00'], o.code);
        })
      }
    },
    //创建订单弹窗方法
    saveTo () {
      var ddlx = this.order.orderCategory
      var ddzlx = this.order.orderCategory1
      var ddzlxfw = this.order.orderCategory2
      this.order.projectName = this.order.projectName || ''
      this.order.submitflag = "初始化"
      if (!ddlx) {
        this.$msg.msge("请完善订单信息后提交!");
        return;
      }
      if (ddlx == '1' && ddzlx == '7') {
        if (!this.order.orderProjectCode) {
          this.$msg.msge("请选择项目信息");
          return;
        }
      }
      if (ddlx == '1' && ddzlx == '8') {
        if (!this.order.orderMainContract) {
          this.$msg.msge("请选择合同信息");
          return;
        }
      }
      if (ddlx == '2' && ddzlx == '43') {
        if (!this.order.orderMainContract) {
          this.$msg.msge("请选择合同信息");
          return;
        }
      }
      if (ddlx == '1' && ddzlx == '9') {
        if (!this.order.orderCategory2) {
          this.$msg.msge("请选择服务订单类型！");
          return;
        }
      }
      if (ddzlx == '6' || ddzlx == '23' || ddzlx == '29') {
        if (!this.order.orderCategory2) {
          this.$msg.msge("请选择免费类型！");
          return;
        }
      }
      if (ddlx == '1' && ddzlx == '14') {
        if (!this.order.orderCategory2) {
          this.$msg.msge("请选择退货类型");
          return;
        }
      }
      console.log(this.order.disChannelCode);

      if (_.isArray(this.order.disChannelCode)) {
        this.order.zcode = this.order.disChannelCode[1] || '';
        this.order.disChannelCode = this.order.disChannelCode[0];
      }

      if (ddlx == '3') {
        if (!this.order.disChannelCode) {
          this.$msg.msge("请选择分销渠道");
          return;
        }
      }
      ss.OrderMainService.initOrder(this.order).then(rd => {
        this.toEdit(ddlx, ddzlx, ddzlxfw, rd.obj.id);
        this.$emit('imgfalse3');
      })

    },
    toEdit (ddlx, ddzlx, ddzlxfw, id) {
      console.log(ddlx, ddzlx, ddzlxfw, id, '确定按钮触发事件')
      if (ddlx == '1') {
        if (ddzlx == '9') {
          if (ddzlxfw == '5' || ddzlxfw == '6') {
            //免费服务订单
            this.$router.push({ path: "/dingd/createMfFuwuOrder", query: { id: id } })
            return;
          } else {
            //服务订单-标准、3Q、直单
            this.$router.push({ path: "/dingd/createFuwuOrder", query: { id: id } })
            return;
          }
          /*                    if(ddzlxfw == '4'){
                                  //服务订单-特价
                                  this.$router.push({path:"/dingd/createFuwuOrder", query:{id:id}})
                                  return;
                              } else {
                                  //服务订单-标准、3Q、直单
                                  this.$router.push({path:"/dingd/createFuwuOrder", query:{id:id}})
                                  return;
                              }*/
          /*                    //服务订单
                              this.$router.push({path:"/dingd/createFuwuOrder", query:{id:id}})
                              return;*/
        } else if (ddzlx == '12') {
          //套餐订单
          if (this.isloud == 1) {
            var item = localStorage.getItem("userId");
            ss.loudnew.isAgentOrderLoud(item).then(res => {
              if (res.msg == '2') {
                this.$router.push({ path: "/dingd/createPackageOrder2", query: { id: id, louds: this.louds } })
              } else {
                this.$message.error("当前经销商在配置表中不存在，请联系管理员！")
                return;
              }
            });
          } else {
            var item = localStorage.getItem("userId");
            ss.loudnew.isAgentOrderLoud(item).then(res => {
              if (res.msg == '2') {
                this.$message.error("当前经销商在配置表中已存在，请在漏斗页面走新流程！")
                return;
              } else {
                this.$router.push({ path: "/dingd/createPackageOrder", query: { id: id } })
              }
            });
          }
        } else if (ddzlx == '14') {
          console.log('跳转退货订单页面')
          this.$router.push({ path: "/dingd/createNxThOrder", query: { id: id, louds: this.louds } })
          return
        } else if (ddzlx == '15') {
          console.log('跳转组合订单')
          this.$router.push({ path: "/dingd/createCombinationOrder", query: { id: id } })
          return;
        }
        if (ddzlx != '12') {   //不是套餐
          //如果是重漏斗界面 点击的一键生单功能 就走新流程 反着还是老流程
          if (ddzlx == '1' || ddzlx == '2' || ddzlx == '11') {
            if (this.isloud == 1) {
              var item = localStorage.getItem("userId");
              ss.loudnew.isAgentOrderLoud(item).then(res => {
                if (res.msg == '2') {
                  this.$router.push({ path: "/dingd/createNxOrder3", query: { id: id, louds: this.louds } })
                } else {
                  this.$message.error("当前经销商在配置表中不存在，请联系管理员！")
                  return
                }
              });
            } else {
              var item = localStorage.getItem("userId");
              ss.loudnew.isAgentOrderLoud(item).then(res => {
                if (res.msg == '2') {
                  this.$message.error("当前经销商在配置表中已存在，请在漏斗页面走新流程！")
                  return
                } else {
                  this.$router.push({ path: "/dingd/createNxOrder", query: { id: id, louds: this.louds } })
                }
              });
            }
          } else {
            this.$router.push({ path: "/dingd/createNxOrder", query: { id: id, louds: this.louds } })
          }
        }
      } else if (ddlx == '2') {
        //外销
        if (ddzlx == '25') {
          //服务订单
          this.$router.push({ path: "/dingd/createWxFuwuOrder", query: { id: id } })
          return;
        }

        //国内外贸公司订单
        if (ddzlx == '26') {
          //服务订单
          this.$router.push({ path: "/dingd/createWMOrder", query: { id: id } })
          return;
        }
        //国内外贸公司订单
        if (ddzlx == '264') {
          //服务订单
          this.$router.push({ path: "/dingd/createWMOverseaOrder", query: { id: id } })
          return;
        }
        //6200独立外销订单
        if (ddzlx == '27') {
          //服务订单
          this.$router.push({ path: "/dingd/createBeiHuoOrder", query: { id: id } })
          return;
        }
        //9390或者9370卖给6200的销售订单
        if (ddzlx == '28') {
          //9390或者9370卖给6200的销售订单
          this.$router.push({ path: "/dingd/createHKOrder", query: { id: id } })
          return;
        }
        //是免费订单6200
        if (ddzlx == '29') {
          this.$router.push({ path: "/dingd/createWxOrder6200", query: { id: id } })
          return;
        }

        //国内外贸公司服务订单
        if (ddzlx == '30') {
          //服务订单
          this.$router.push({ path: "/dingd/createWMFwOrder", query: { id: id } })
          return;
        }
        if (ddzlx == '41') {
          this.$router.push({ path: "/dingd/createWxOrderUsa", query: { id: id } })
          return;
        }
        if (ddzlx == '42') {
          this.$router.push({ path: "/dingd/createWxOrderSales", query: { id: id } })
          return;
        }
        if (ddzlx == '43') {
          //外销租赁订单
          this.$router.push({ path: "/dingd/createNwSaleOrder", query: { id: id } })
          return;
        }
        //外销标准订单
        if (ddzlx == '214') {
          this.$router.push({ path: "/dingd/createWxOrderBZ", query: { id: id } })
          return;
        }
        //外销组合订单
        if (ddzlx == '44') {
          this.$router.push({ path: "/dingd/createOverseaOrder", query: { id: id } })
          return;
        }

        this.$router.push({ path: "/dingd/createWxOrder", query: { id: id } })
        return;
      } else {
        this.$router.push({ path: "/dingd/createShanghOrder", query: { id: id } })
        return;
      }
    },
    cancel () {
      this.tableData2 = [];
      this.selectedOptions = [];
      this.$emit('imgfalse3');
    },

    handleEdit (row) {
      // console.log(row)
      this.toEdit(row.orderCategory, row.orderCategory1, row.orderCategory2, id);
    },
    handelDetail (row) {
      this.$router.push({ path: "/dingdmain/viewdetail", query: { id: row.id, instid: row.instid } })
    },
    closeIt () {
      this.showOrhide = false;
      if (this.checked) {
        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
          // console.log(rd)
          this.showOrhide = false;
        })
      } else {
        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
          // console.log(rd)
          this.showOrhide = false;
        })
      }
    },
    nextStep (i) {
      if (this.status == 1) {
        this.status = 2;

      } else if (this.status == 2) {
        if (this.checked) {
          this.status = 3;
          ss.salesList.toshow(this.toshow, this.checked).then(rd => {
            // console.log(rd)
            this.showOrhide = false;
          })
        } else {
          ss.salesList.toshow(this.toshow, this.checked).then(rd => {
            // console.log(rd)
            this.showOrhide = false;
          })
        }


      }
    },
    showzhezhao () {
      ss.salesList.toshow(this.toshow).then(rd => {
        // console.log(rd)
        if (rd == false) {
          this.showOrhide = false;
        } else {
          this.showOrhide = true;
        }
      })
    }
  },
  mounted () {

  },
  beforeCreate () {

  },
  props: {
    dialogVisible: {
      type: Boolean,
    },
    isloud: Number,
    ddlx: '',
    louds: [],
  }
}
</script>
<style>
.D-date .h-dialogForm .h-elformWrap-2 {
  width: 50% !important;
  padding-right: 0;
}
.D-date .h-elformWrap-2 .el-form-item__label {
  width: 38% !important;
}
.D-date .h-elformWrap-2 .el-form-item__content {
  width: 62% !important;
}
.D-date .el-cascader {
  line-height: 0;
}
.el-cascader-menu__wrap {
  height: auto;
}
</style>
<style scoped lang="scss">
.bottomTip {
  position: absolute;
  left: 49.7%;
  bottom: 0.3rem;
  transform: translateX(-50%);
}
.newtext {
  font-size: 0.28rem;
  color: white;
  position: absolute;
  top: 0.2rem;
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
  text-shadow: 1px 1px 4px #2785e7;
  z-index: 2;
}
.leaderBox {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  z-index: 99999;
  overflow: hidden;
  top: 0;
  left: 0;
  .leaderbg {
    width: 100%;
    height: 100%;
  }
  .steps {
    position: absolute;
    z-index: 1;
  }
  .step1 {
    top: 3.4rem;
    left: 3.1rem;
    width: 10.2rem;
    height: 1.4rem;
  }
  .step2 {
    top: 5.05rem;
    right: 5.88rem;
    width: 3.7rem;
    height: 0.9rem;
  }
  .stepbtn {
    width: 1.9rem;
    height: 0.6rem;
    border: 0.03rem solid #ffffff;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    line-height: 0.5rem;
    position: absolute;
    z-index: 99;
    bottom: 0.75rem;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0.27rem;
    letter-spacing: 2px;
    color: white;
    cursor: pointer;
  }
  .closeIt {
    width: 0.3rem;
    height: 0.3rem;
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;
    cursor: pointer;
  }
}
</style>
